module.exports = __webpack_public_path__ + "static/img/entertainment.3290844.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/entertainment.jpg
// module id = egoL
// module chunks = 58